@if (isViewMode) {
<!-- Modal layout -->
<div class="modal-header">
  <h4 class="modal-title">{{ "Document" | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>

<div>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ "Close" | translate }}
  </button>
</div>
} @else {
<!-- Normal inline -->
<ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <div>
    <div class="card">
      <div
        class="card-header border-bottom card-tabs d-flex flex-wrap align-items-center gap-2"
      >
        <div class="flex-grow-1">
          @if (!isViewMode) {
          <h4 class="header-title">{{ "Document" | translate }}</h4>
          }
        </div>

        <div class="d-flex flex-wrap flex-lg-nowrap gap-2">
          <div class="flex-shrink-0 d-flex align-items-center gap-2">
            <div class="position-relative">
              <input
                type="search"
                class="form-control ps-4"
                [(ngModel)]="searchText"
                (ngModelChange)="searchfilter()"
                [placeholder]="'Search here' | translate"
              />
              <i
                class="ti ti-search position-absolute top-50 translate-middle-y start-0 ms-2"
              ></i>
            </div>
          </div>
          @if (!isViewMode) {
          <a (click)="addEditDocument()" class="btn btn-primary"
            ><i class="ti ti-plus me-1"></i> {{ "Add Document" | translate }}</a
          >
          }
        </div>
      </div>
      <ngx-simplebar
        class="card-body py-0 mb-3"
        data-simplebar
        [options]="{ autoHide: false }"
        [style.max-height.px]="modalMaxHeight"
      >
        <div>
          <app-grid-table
            (sort)="onCompleteSort($event)"
            [columns]="columns"
            [records]="documents"
            (onSearch)="onSearch($event)"
            [isLoading]="isLoading"
          >
            <ng-template #rows let-document="item" let-index="index">
              <td>
                <div class="d-flex">
                  <div class="align-content-center ms-2">
                    {{ document.file_name }}
                  </div>
                </div>
              </td>
              <td>
                {{ document.document_type_name }}
              </td>
              <td>
                {{ document.file_extension }}
              </td>
              <td>
                {{ document.created_date_str }}
              </td>
              <td>
                {{ document.expiry_date_str }}
              </td>
              <td>
                <div class="hstack gap-1 justify-content-center">
                  <a
                    (click)="download(document)"
                    href="javascript:void(0);"
                    class="btn btn-soft-info btn-icon btn-sm rounded-circle"
                  >
                    <i class="ti ti-download fs-16"></i
                  ></a>
                  @if (!isViewMode) {
                  <a
                    (click)="addEditDocument(document)"
                    href="javascript:void(0);"
                    class="btn btn-soft-success btn-icon btn-sm rounded-circle"
                  >
                    <i class="ti ti-edit fs-16"></i
                  ></a>
                  <a
                    (click)="deleteConfirm(document, index)"
                    href="javascript:void(0);"
                    class="btn btn-soft-danger btn-icon btn-sm rounded-circle"
                  >
                    <i class="ti ti-trash fs-16"></i
                  ></a>
                  }
                </div>
              </td>
            </ng-template>
          </app-grid-table>
        </div>
      </ngx-simplebar>
    </div>
  </div>
</ng-template>
